import axios from '@axios'

export const state = {
  towings: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allTowings: (state) => state.towings,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  GET_TOWINGS: (state, resp) => {
    if (!resp) return null
    state.towings = resp.towings
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_TOWINGS: (state, towing) => {
    towing.id = new Date().getTime()
    state.towings.push(towing)
  },
  UPDATE_TOWINGS: (state, towing) => {
    for (let i = 0; i < state.towings.length; i++) {
      if (state.towings[i].id === towing.id) {
        towing.id = new Date().getTime()
        for (let field in state.towings[i]) {
          state.towings[i][field] = towing[field]
        }
        break
      }
    }
  },
  REMOVE_TOWINGS: (state, towing) => {
    state.towings = state.towings.filter((m) => m.id !== towing.id)
  },
}

export const actions = {
  async getTowings({ commit }, params = {}) {
    await axios
      .get('/api/towings', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TOWINGS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_TOWINGS',
          err.response.status === 404 ? { towings: [] } : null
        )
      })
  },

  async createTowings({ commit }, towing) {
    return axios.post('/api/towings', towing)
  },
  async updateTowings({ commit }, towing) {
    /* do not remove unused commit, it is used to avoid critical error */
    return axios.put('/api/towings', towing)
  },
  async deleteTowings({ commit, dispatch }, towing) {
    await axios.delete('/api/towings', { data: towing }).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_TOWINGS', towing)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The towing has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
  async exportTowings({ commit }, params) {
    return axios.post('/api/towings/export', { params: params })
  },
}
